import { render } from "./2.GetInTouch.vue?vue&type=template&id=68cdc6da&scoped=true"
import script from "./2.GetInTouch.vue?vue&type=script&lang=js"
export * from "./2.GetInTouch.vue?vue&type=script&lang=js"

import "./2.GetInTouch.vue?vue&type=style&index=0&id=68cdc6da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cdc6da"]])

export default __exports__